/**
 * User repository – Firestore access for users. Observer pattern via onSnapshot.
 */
import { collection, doc, getDoc, setDoc, onSnapshot, query, limit, getDocs } from 'firebase/firestore';
import { db } from '../firebase/config';
import { createUser } from '../../domain/entities/User';

const COLLECTION = 'users';

export function getUserRef(userId) {
  return doc(db, COLLECTION, userId);
}

export function userRepository({ getFirestore = () => db } = {}) {
  const firestore = getFirestore();

  return {
    async getById(userId) {
      const ref = doc(firestore, COLLECTION, userId);
      const snap = await getDoc(ref);
      if (!snap.exists()) return null;
      return createUser({ id: snap.id, ...snap.data() });
    },

    subscribe(userId, onUpdate) {
      const ref = doc(firestore, COLLECTION, userId);
      return onSnapshot(ref, (snap) => {
        if (!snap.exists()) {
          onUpdate(null);
          return;
        }
        onUpdate(createUser({ id: snap.id, ...snap.data() }));
      });
    },

    async set(userId, data) {
      const ref = doc(firestore, COLLECTION, userId);
      await setDoc(ref, { ...data, updatedAt: new Date() }, { merge: true });
    },

    async list(limitCount = 100) {
      const q = query(collection(firestore, COLLECTION), limit(limitCount));
      const snap = await getDocs(q);
      return snap.docs.map((d) => createUser({ id: d.id, ...d.data() }));
    },
  };
}

export const userRepo = userRepository();
